import {CSSProperties, FC} from 'react';


export interface IIconGooglePlusProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconGooglePlus: FC<IIconGooglePlusProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 24c6.624 0 12-5.376 12-12S18.624 0 12 0 0 5.376 0 12s5.376 12 12 12Zm4.283-12.857h1.718V9.426h1.718v1.718h1.703v1.718h-1.703v1.718h-1.718v-1.718h-1.718v-1.719ZM8.579 5.999c1.514 0 2.908.533 4.017 1.563L10.97 9.14c-.639-.625-1.514-.924-2.391-.924-2.076 0-3.736 1.718-3.736 3.779s1.655 3.779 3.736 3.779c1.577 0 3.14-.924 3.392-2.579H8.579v-2.061h5.657c.063.329.092.658.092 1.001 0 3.426-2.299 5.864-5.749 5.864V18a5.991 5.991 0 0 1-6.001-6.001c0-3.315 2.672-6 6.001-6Z" clipRule="evenodd" />
        </svg>
    );
};
